import { type ClassValue, clsx } from "clsx";
import { createTwc } from "react-twc";
import { extendTailwindMerge } from "tailwind-merge";

const isSizeToken = (v: string) => v.startsWith("size-");
const isTextColorToken = (v: string) => v.startsWith("text-");

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [isSizeToken] }],
      "text-color": [{ text: [isTextColorToken] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const twc = createTwc({ compose: cn });

export type { TwcComponentProps } from "react-twc";
